import { render, staticRenderFns } from "./HandicapDetailDialog.vue?vue&type=template&id=352b8566&scoped=true"
import script from "./HandicapDetailDialog.vue?vue&type=script&lang=js"
export * from "./HandicapDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./HandicapDetailDialog.vue?vue&type=style&index=0&id=352b8566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b8566",
  null
  
)

export default component.exports